import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class Thumbnails {

  #rmp;
  #dummyThumbnailsImg = null;
  #onThumbnailsLoadFn = null;
  #onThumbnailsErrorFn = null;
  #thumbnailsArray = [];
  #thumbnailURIs = [];
  #thumbnailURIsTimestamps = [];
  #currentThumbnailURI = '';

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get array() {
    return this.#thumbnailsArray;
  }

  get uris() {
    return this.#thumbnailURIs;
  }

  get urisTimestamps() {
    return this.#thumbnailURIsTimestamps;
  }

  get currentURI() {
    return this.#currentThumbnailURI;
  }

  set currentURI(uri) {
    if (uri) {
      this.#currentThumbnailURI = uri;
    }
  }

  #resetDummyThumbnailsImg() {
    if (this.#dummyThumbnailsImg) {
      this.#dummyThumbnailsImg.removeEventListener('load', this.#onThumbnailsLoadFn);
      this.#dummyThumbnailsImg.removeEventListener('error', this.#onThumbnailsErrorFn);
      this.#dummyThumbnailsImg = null;
    }
  }

  #onThumbnailsLoad(thumbnailsURL) {
    this.#resetDummyThumbnailsImg();
    this.appendThumbnailsElement();
    this.#rmp.dom.thumbnailsElement.style.backgroundImage = 'url("' + thumbnailsURL + '")';
  }

  #onThumbnailsError(warning) {
    this.#resetDummyThumbnailsImg();
    this.#rmp.rmpUtils.warning(8001, warning);
  }

  #parseThumbnailsVtt(data) {
    const lines = data.split(/(\r\n|\r|\n)/g);
    const re1 = /^\s*$/;
    const vttArray = [];
    for (let i = 0, len = lines.length; i < len; i++) {
      if (!re1.test(lines[i])) {
        vttArray.push(lines[i]);
      }
    }
    const re2 = /WEBVTT/i;
    if (!re2.test(vttArray[0])) {
      this.#rmp.rmpUtils.warning(8002);
      return;
    }
    vttArray.shift();

    this.#thumbnailURIs = [];
    this.#thumbnailURIsTimestamps = [];
    const fqUrlPattern = /^(https?:)?\/\//i;
    const re3 = /^\s*\d*?:?\d*?:?\d+(\.\d+)?\s*-->\s*\d*?:?\d*?:?\d+(\.\d+)?\s*$/;
    for (let i = 0, len = vttArray.length; i < len; i++) {
      if (vttArray[i] && vttArray[i + 1] && re3.test(vttArray[i])) {
        const splitTime = (vttArray[i]).split('-->');
        const splitThumbnailsURL = (vttArray[i + 1]).split('#xywh=');
        if (splitTime.length === 2 && (splitThumbnailsURL.length === 2 || splitThumbnailsURL.length === 1)) {
          const start = (splitTime[0]).trim();
          const end = (splitTime[1]).trim();
          const newThumbnailData = [FW.dateToSeconds(start), FW.dateToSeconds(end)];
          let thumbnailsURL = splitThumbnailsURL[0];
          if (!fqUrlPattern.test(thumbnailsURL)) {
            thumbnailsURL = FW.getFQURL(this.#rmp.seekBarThumbnailsLoc, thumbnailsURL);
          }
          if (this.#thumbnailURIs.indexOf(thumbnailsURL) === -1) {
            this.#thumbnailURIs.push(thumbnailsURL);
            this.#thumbnailURIsTimestamps.push(FW.dateToSeconds(start));
          }
          if (splitThumbnailsURL[1]) {
            newThumbnailData.push(splitThumbnailsURL[1]);
          } else {
            newThumbnailData.push('0,0,128,72');
          }
          this.#thumbnailsArray.push(newThumbnailData);
        }
      }
    }
    if (this.#thumbnailsArray.length === 0 || this.#thumbnailURIs === 0 ||
      this.#thumbnailURIsTimestamps === 0) {
      this.#rmp.rmpUtils.warning(8003);
      return;
    }
    Logger.print('thumbnails', 'parsed VTT file');
    this.#rmp.dispatch('thumbnailsparsed');
    Logger.print('thumbnails', 'sprite images follow', this.#thumbnailsArray);
    this.#dummyThumbnailsImg = document.createElement('img');
    this.#currentThumbnailURI = this.#thumbnailURIs[0];
    this.#onThumbnailsLoadFn = this.#onThumbnailsLoad.bind(this, this.#currentThumbnailURI);
    this.#onThumbnailsErrorFn = this.#onThumbnailsError.bind(this);
    this.#dummyThumbnailsImg.addEventListener('load', this.#onThumbnailsLoadFn);
    this.#dummyThumbnailsImg.addEventListener('error', this.#onThumbnailsErrorFn);
    this.#dummyThumbnailsImg.src = this.#currentThumbnailURI;
  }

  appendThumbnailsElement() {
    this.#rmp.dom.thumbnailsElement = FW.createElement('div', 'rmp-thumbnails');
    this.#rmp.dom.seekBar.classList.add('rmp-seek-bar-thumbnails');
    this.#rmp.dom.container.classList.add('rmp-seek-bar-thumbnails-ui');
    this.#rmp.dom.indicator.appendChild(this.#rmp.dom.thumbnailsElement);
  }

  destroy() {
    this.#resetDummyThumbnailsImg();
    this.#rmp.dom.seekBar.classList.remove('rmp-seek-bar-thumbnails');
    this.#rmp.dom.container.classList.remove('rmp-seek-bar-thumbnails-ui');
    FW.removeElement(this.#rmp.dom.thumbnailsElement);
  }

  init() {
    FW.ajax(this.#rmp.seekBarThumbnailsLoc, this.#rmp.ajaxWithCredentials, 'GET').
      then(data => {
        Logger.print('thumbnails', 'loaded VTT thumbnail file at ' + this.#rmp.seekBarThumbnailsLoc);
        this.#rmp.dispatch('thumbnailsloaded');
        if (typeof data === 'string') {
          this.#parseThumbnailsVtt(data);
        }
      }).catch(error => {
        this.#rmp.rmpUtils.warning(8000, error);
      });
  }
}
